import { IntlShape } from 'react-intl';

type TranslationFunction = (intl: IntlShape) => string;

const calculations: Record<string, TranslationFunction> = {
  'v1:accrual:column_calculations:this_month_vs_last_month': intl =>
    intl.formatMessage({ id: 'calculations.this_month_vs_last_month', defaultMessage: 'This month vs Last month' }),
  'v1:accrual:column_calculations:this_month_vs_last_year': intl =>
    intl.formatMessage({ id: 'calculations.this_month_vs_last_year', defaultMessage: 'This month vs Last year' }),
  'v1:accrual:column_calculations:this_month_to_date_vs_last_month': intl =>
    intl.formatMessage({ id: 'calculations.this_month_to_date_vs_last_month', defaultMessage: 'MTD vs Last Month' }),
  'v1:accrual:column_calculations:this_month_to_date_vs_last_month_to_date': intl =>
    intl.formatMessage({
      id: 'calculations.this_month_to_date_vs_last_month_to_date',
      defaultMessage: 'MTD vs Last MTD'
    }),
  'v1:accrual:column_calculations:this_quarter_vs_last_quarter': intl =>
    intl.formatMessage({
      id: 'calculations.this_quarter_vs_last_quarter',
      defaultMessage: 'This quarter vs Last quarter'
    }),
  'v1:accrual:column_calculations:this_quarter_vs_last_year': intl =>
    intl.formatMessage({ id: 'calculations.this_quarter_vs_last_year', defaultMessage: 'This quarter vs LY' }),
  'v1:accrual:column_calculations:this_quarter_to_date_vs_last_quarter': intl =>
    intl.formatMessage({
      id: 'calculations.this_quarter_to_date_vs_last_quarter',
      defaultMessage: 'QTD vs Last quarter'
    }),
  'v1:accrual:column_calculations:this_quarter_to_date_vs_last_quarter_to_date': intl =>
    intl.formatMessage({
      id: 'calculations.this_quarter_to_date_vs_last_quarter_to_date',
      defaultMessage: 'QTD vs Last QTD'
    }),
  'v1:accrual:column_calculations:this_fy_vs_last_fy': intl =>
    intl.formatMessage({ id: 'calculations.this_fy_vs_last_fy', defaultMessage: 'FY vs LY' }),
  'v1:accrual:column_calculations:this_fy_to_date_vs_last_fy': intl =>
    intl.formatMessage({ id: 'calculations.this_fy_to_date_vs_last_fy', defaultMessage: 'YTD vs LY' }),
  'v1:accrual:column_calculations:this_fy_to_date_vs_last_fy_to_date': intl =>
    intl.formatMessage({
      id: 'pds.reporting.heading.fy_to_date_vs_last_fy_to_date',
      description: 'Variance column: current financial year to date vs last financial year to date',
      defaultMessage: 'YTD vs LYTD'
    }),
  'v1:accrual:column_calculations:period_percent_variance': intl =>
    intl.formatMessage({ id: 'calculations.period_percent_variance', defaultMessage: 'Period % variance' }),
  'v1:accrual:column_calculations:period_variance': intl =>
    intl.formatMessage({ id: 'calculations.period_variance', defaultMessage: 'Period variance' }),
  'v1:accrual:column_calculations:fy_totals': intl =>
    intl.formatMessage({ id: 'calculations.fy_totals', defaultMessage: 'FY totals' }),
  'v1:accrual:column_calculations:percent_of_revenue': intl =>
    intl.formatMessage({
      id: 'pds.reporting.heading.percent_of_revenue',
      description: 'Variance column: the previous column value expressed as a percent of revenue',
      defaultMessage: '% of revenue'
    }),
  'v1:accrual:column_calculations:total': intl =>
    intl.formatMessage({
      id: 'pds.reporting.heading.total',
      description: 'Variance column: the total of the previous columns',
      defaultMessage: 'Total'
    }),
  'v1:accrual:column_calculations:average': intl =>
    intl.formatMessage({
      id: 'pds.reporting.heading.average',
      description: 'Variance column: the average (mean) of the previous columns',
      defaultMessage: 'Average'
    }),
  'v1:accrual:column_calculations:start_end_variance': intl =>
    intl.formatMessage({ id: 'calculations.start_end_variance', defaultMessage: 'Start/end variance' }),
  'v1:accrual:column_calculations:start_end_percent_variance': intl =>
    intl.formatMessage({ id: 'calculations.start_end_percent_variance', defaultMessage: 'Start/end variance %' }),
  'v1:accrual:column_calculations:month_to_date': intl =>
    intl.formatMessage({
      id: 'pds.reporting.heading.month_to_date',
      description: 'Variance column: month to date',
      defaultMessage: 'MTD'
    }),
  'v1:accrual:column_calculations:quarter_to_date': intl =>
    intl.formatMessage({
      id: 'pds.reporting.heading.quarter_to_date',
      description: 'Variance column: quarter to date',
      defaultMessage: 'QTD'
    }),
  'v1:accrual:column_calculations:fy_to_date': intl =>
    intl.formatMessage({ id: 'calculations.fy_to_date', defaultMessage: 'Financial YTD' }),
  'v1:accrual:column_calculations:fy_to_report_end': intl =>
    intl.formatMessage({ id: 'calculations.fy_to_report_end', defaultMessage: 'FY to report end' }),
  'v1:accrual:column_calculations:financial_year_summary': intl =>
    intl.formatMessage({ id: 'calculations.financial_year_summary', defaultMessage: 'Financial Year Summary' })
};

export const translateCalculation = (ref: string, intl: IntlShape) => {
  return calculations[ref] ? calculations[ref](intl) : '';
};
